import {
  ADD_STUDENTS_TO_LIST,
  CLEAR_STUDENTS_LIST_FILTERS,
  RESET_STUDENTS_MODULE,
  SET_LAST_PAGE,
  SET_SORTING,
  SET_STUDENT_LIST_SCROLL_TOP,
  SET_STUDENT_LIST_SEARCH_FIELD,
  SET_STUDENT_LIST_SEARCH_FIELD_DISPLAY,
  SET_TOTAL_ELEMENTS,
  SOFT_RESET_STUDENT_LIST,
  STUDENTS_LIST_LOADING,
  STUDENTS_LIST_NOT_LOADING,
  TOGGLE_STUDENTS_LIST_FILTER,
  TOGGLE_DASHBOARD_FILTER,
  TOGGLE_INTERACTIONS_LIST_FILTER,
  SET_STUDENTS_LIST_FILTER_ARRAY,
  SET_STUDENTS_LIST_IS_FILTERING,
  SET_COURSES_FOR_STUDENTS,
  UPDATE_PAGE,
  SET_STUDENT_CUSTOM_BUTTON_FILTER_TYPE,
  SET_STUDENT_CUSTOM_LIST_FILTER_TYPE,
  SET_IS_TUTOR,
  CLEAR_DASHBOARD_FILTERS,
  EMPTY_INTERACTIONS_LIST,
  SET_STUDENT_BUTTON_FILTER_TYPE,
  SET_STUDENT_LIST_FILTER_TYPE,
  SET_SAVED_FILTERS_FOR_STAFF,
  HIDE_SAVED_FILTER_BY_ID,
  SET_UNDO_TYPE,
  SHOW_SAVED_FILTER_BY_ID,
  SAVE_DELETED_FILTER_ID,
  SET_INFORMATION_SNACKBAR_TEXT,
  SET_INFORMATION_SNACKBAR_STATE,
  STUDENT_REPORT_LOADING,
  STUDENT_REPORT_LOADING_LABEL,
  STUDENT_REPORT_FINISHED_LOADING,
  STUDENT_REPORT_FINISHED_LABEL,
  DASHBOARD_CHARTS_NOT_CACHED,
  RESET_DASHBOARD_MODULE,
  HOLD_DEFAULT_SEARCH,
  BUILD_MY_STUDENT_ELEMENTS, SET_MY_STUDENT_COLUMNS
} from '../mutation-types'
import {
  CHANGE_SORTING,
  CLEAR_STUDENTS_LIST_FILTERS_ACTION,
  GET_LIST_OF_STUDENTS,
  GET_LIST_OF_STUDENTS_FOR_ENGAGEMENT,
  LOGOUT,
  SEARCH_LIST_OF_STUDENTS,
  STUDENTS_LIST_CHANGE_FILTER,
  STUDENTS_LIST_CHANGE_LIST_FILTER,
  GET_COURSES_FOR_STUDENTS,
  GET_CUSTOM_FILTERS_FOR_STUDENTS,
  GET_INTERACTIONS_LIST_START,
  GET_STUDY_MODES_STUDENTS,
  GET_ENROLMENT_STATUS_STUDENTS,
  GET_TUTOR_BOOLEAN,
  GET_COURSE_YEARS_STUDENTS,
  GET_COURSE_LEVELS_STUDENTS,
  DELETE_SAVED_FILTER,
  GET_SAVED_FILTERS_FOR_STAFF,
  SET_UNDO_STATE_ASYNC,
  SAVE_UPDATE_MY_FILTER,
  DOWNLOAD_STUDENT_REPORT, ORGANISE_SAVED_FILTERS_FOR_STAFF, CLEAR_SAVED_FILTERS_FOR_STAFF, GET_MY_STUDENT_COLUMNS
} from '../action-types'
import axios from 'axios/index'
import { clearFilters, getAppliedFilters } from '../../HelperMethods'
import Vue from 'vue'
import store from '../../store'
import {undoTypes} from './undo'
import {informationTexts} from './information'
import FileSaver from 'file-saver'

const state = () => ({
  students: [],
  currentPage: -1,
  totalElements: 0,
  pageSize: 50,
  lastPage: false,
  sortBy: 'LAST_NAME:::ASC',
  courseLevel: '',
  studyMode: '',
  enrolmentStatus: '',
  searchString: null,
  searchStringDisplay: '',
  loading: false,
  scrollTop: 0,
  filtersChanged: false,
  filtersApplied: false,
  customFilterNames: [],
  lastDeletedFilterId: null,
  defaultSearch: false,
  report_downloading: false,
  report_download_button_label: 'student.report_download',
  showFilterDefaultOption: true,
  showFilterDeleteOption: true,
  holdDefaultSearch: false,
  sortFields: [
    {
      'text': 'surname_asc',
      'value': 'LAST_NAME:::ASC'
    },
    {
      'text': 'surname_desc',
      'value': 'LAST_NAME:::DESC'
    },
    {
      'text': 'rating_asc',
      'value': 'ENGAGEMENT_RATING:::ASC'
    },
    {
      'text': 'rating_desc',
      'value': 'ENGAGEMENT_RATING:::DESC'
    }
  ],
  filterFields: {
    myFilterIds: {
      header: 'student.filters.headers.myFilters',
      isList: true,
      listName: 'myFilterIds',
      values: {},
      myFilters: []
    },
    myTutees: {
      header: 'student.filters.headers.tutees',
      isNotTutor: true,
      values: {
        MY_TUTEES: {
          value: false,
          text: 'student.filters.values.my_tutees'
        }
      }
    },
    engagementRatings: {
      header: 'student.filters.headers.engagement',
      values: {
        NONE: {
          value: false,
          text: 'student.filters.values.none'
        },
        VERY_LOW: {
          value: false,
          text: 'student.filters.values.very_low'
        },
        LOW: {
          value: false,
          text: 'student.filters.values.low'
        },
        PARTIAL: {
          value: false,
          text: 'student.filters.values.partial'
        },
        GOOD: {
          value: false,
          text: 'student.filters.values.good'
        },
        HIGH: {
          value: false,
          text: 'student.filters.values.high'
        }
      }
    },
    averageEngagementRatings: {
      header: 'student.filters.headers.average',
      values: {
        NONE: {
          value: false,
          text: 'student.filters.values.none'
        },
        VERY_LOW: {
          value: false,
          text: 'student.filters.values.very_low'
        },
        LOW: {
          value: false,
          text: 'student.filters.values.low'
        },
        PARTIAL: {
          value: false,
          text: 'student.filters.values.partial'
        },
        GOOD: {
          value: false,
          text: 'student.filters.values.good'
        },
        HIGH: {
          value: false,
          text: 'student.filters.values.high'
        }
      }
    },
    courseIds: {
      header: 'student.filters.headers.courses',
      isList: true,
      listName: 'courseIds',
      values: {},
      courses: []
    }
  },
  listSources: {
    courseIds: {
      identifier: 'course',
      title_i18n: 'student.filters.course_selection',
      items: [],
      idValues: {},
      button_i18n: 'student.filters.courses_button',
      button_unselected_i18n: 'student.filters.courses_button_unselected',
      containsText (item, text) {
        return (item.courseDescription.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
               (item.courseIdentifier.toUpperCase().indexOf(text.toUpperCase()) >= 0)
      },
      key (item) {
        return item.courseIdentifier
      },
      mapRow (item) {
        return {
          rows: [item.courseDescription, item.courseIdentifier],
          id: item.id
        }
      }
    },
    myFilterIds: {
      identifier: 'myFilter',
      title_i18n: 'student.filters.myfilter_selection',
      items: [],
      idValues: {},
      button_i18n: '{count} myFilter ::: {count} myFilters',
      button_unselected_i18n: 'student.filters.myfilter_button_unselected',
      containsText (item, text) {
        return (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
          (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0)
      },
      key (item) {
        return item.description
      },
      mapRow (item) {
        return {
          rows: [item.description],
          id: item.id,
          defaultSearch: item.defaultSearch
        }
      }
    }
  },
  headers: {},
  elementCount: 7,
  functions: {
    myStudents: 'MYSTUDENT'
  },
  options: {
    enable: {
      alertColumn: 'ENBALTCOL',
      myFilter: 'ENBMYFIL',
      downloadStudent: 'ENBDLSRPT',
      averageEngagement: 'ENBABGENG',
      interventionColumn: 'ENBINTCOL',
      studentActionBtn: 'ENBINTABTN'
    }
  }
})

const actions = {
  [SEARCH_LIST_OF_STUDENTS] ({commit, dispatch, state}, searchString) {
    const previousSearchString = state.searchString
    const currentSearchString = searchString.trim().length > 2 ? searchString.trim() : null

    commit(SET_STUDENT_LIST_SEARCH_FIELD, currentSearchString)
    commit(SET_STUDENT_LIST_SEARCH_FIELD_DISPLAY, searchString)
    if (currentSearchString !== previousSearchString) {
      commit(SOFT_RESET_STUDENT_LIST)
      dispatch(GET_LIST_OF_STUDENTS)
    }
  },
  [CHANGE_SORTING] (context, sortField) {
    context.commit(SOFT_RESET_STUDENT_LIST)
    context.commit(SET_SORTING, sortField)
    context.dispatch(GET_LIST_OF_STUDENTS)
  },
  [STUDENTS_LIST_CHANGE_FILTER] ({commit, dispatch, state}, filterObject) {
    // Toggle my students filter buttons
    commit(TOGGLE_STUDENTS_LIST_FILTER, filterObject)
    // check if my tutees filter button has been applied
    if (filterObject['filterType'] === 'myTutees') {
      // Toggle dashboard filter buttons
      commit(TOGGLE_DASHBOARD_FILTER, filterObject)
      // Toggle interactions filter buttons
      commit(TOGGLE_INTERACTIONS_LIST_FILTER, filterObject)
      // Call endpoints for interactions
      commit(EMPTY_INTERACTIONS_LIST)
      dispatch(GET_INTERACTIONS_LIST_START)
    }
    // Call endpoints for my students
    commit(SOFT_RESET_STUDENT_LIST)
    dispatch(GET_LIST_OF_STUDENTS)
  },
  [STUDENTS_LIST_CHANGE_LIST_FILTER] ({commit, dispatch}, filterObject) {
    commit(SET_STUDENTS_LIST_FILTER_ARRAY, filterObject)
    commit(SOFT_RESET_STUDENT_LIST)
    dispatch(GET_LIST_OF_STUDENTS)
  },
  [CLEAR_STUDENTS_LIST_FILTERS_ACTION] ({commit, dispatch, state}) {
    // Clear all my student filters
    commit(CLEAR_STUDENTS_LIST_FILTERS)
    // Clear all dashboard filters (since only filter is myTutees)
    commit(CLEAR_DASHBOARD_FILTERS)
    // Toggle 'myTutees' interactions filter button (only)
    commit(TOGGLE_INTERACTIONS_LIST_FILTER, {filterType: 'myTutees', filterName: 'MY_TUTEES'})
    // clear list types
    Object.keys(state.listSources).forEach((filterType) => {
      commit(SET_STUDENTS_LIST_FILTER_ARRAY, {filterName: [], filterType: filterType})
    })
    // Re-call endpoints for interactions
    commit(EMPTY_INTERACTIONS_LIST)
    dispatch(GET_INTERACTIONS_LIST_START)
    // Re-call endpoints for my students
    commit(SOFT_RESET_STUDENT_LIST)
    dispatch(GET_LIST_OF_STUDENTS)
  },
  [GET_LIST_OF_STUDENTS] ({commit, state, rootState}) {
    if ((!state.loading && !state.lastPage) || state.filtersChanged) {
      commit(STUDENTS_LIST_LOADING)
      const actionData = { action: GET_LIST_OF_STUDENTS, data: undefined }
      let filters = getAppliedFilters(state.filterFields)

      solveCustomFilters(filters, state.customFilterNames)

      let hasFilters = Object.values(filters).reduce((filtered, filter) => {
        return filtered || (filter !== null)
      }, false)
      commit(SET_STUDENTS_LIST_IS_FILTERING, hasFilters)

      axios({
        url: `${rootState.config.baseUrl}:${rootState.config.port}/core/student/filter`,
        method: 'post',
        data: {
          pageNumber: state.currentPage + 1,
          pageSize: state.pageSize,
          ascDesc: state.sortBy.split(':::')[1],
          sortBy: state.sortBy.split(':::')[0],
          searchString: state.searchString,
          ...filters
        },
        headers: {
          'Authorization': rootState.profile.loginToken
        },
        actionData
      })
        .then((res) => {
          commit(STUDENTS_LIST_NOT_LOADING)
          commit(ADD_STUDENTS_TO_LIST, res.data.content)
          commit(UPDATE_PAGE)
          commit(SET_LAST_PAGE, res.data.last)
          commit(SET_TOTAL_ELEMENTS, res.data.totalElements)
        })
        .catch((err) => {
          console.log('Failed to get student list')
          console.error(err)
          commit(STUDENTS_LIST_NOT_LOADING)
        })
    }
  },
  [GET_LIST_OF_STUDENTS_FOR_ENGAGEMENT] ({commit, dispatch, state}, engagement) {
    // set value before resetting
    let isTutorFilterOn = state.filterFields.myTutees.values.MY_TUTEES.value
    // Reset my students filters
    commit(RESET_STUDENTS_MODULE)
    if (isTutorFilterOn) {
      // re-toggle the 'myTutees' filter button
      commit(TOGGLE_STUDENTS_LIST_FILTER, {
        filterType: 'myTutees',
        filterName: 'MY_TUTEES'
      })
    }
    // toggle the 'engagementRatings' filter button
    commit(TOGGLE_STUDENTS_LIST_FILTER, {
      filterType: 'engagementRatings',
      filterName: engagement
    })
    // hold default search
    commit(HOLD_DEFAULT_SEARCH, true)
    // fetch other filters
    dispatch(GET_STUDY_MODES_STUDENTS)

    // call my students endpoint
    dispatch(GET_LIST_OF_STUDENTS)
  },
  [GET_STUDY_MODES_STUDENTS] ({commit, dispatch, rootState}) {
    const actionData = { action: GET_STUDY_MODES_STUDENTS, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/studymode/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filterObject = {
          filterIdentifier: 'studyModes',
          filterName: 'student.filters.headers.study_mode',
          filterAdditionalDescription: 'student.filters.headers.study_mode_additional_description'
        }
        if (res.data.length > 6) {
          commit(SET_STUDENT_LIST_FILTER_TYPE, {filters: res.data, studentFilterObject: filterObject})
        } else {
          commit(SET_STUDENT_BUTTON_FILTER_TYPE, {filters: res.data, studentFilterObject: filterObject})
        }
        dispatch(GET_COURSE_YEARS_STUDENTS)
      })
      .catch((err) => {
        console.log('Failed to get study mode student filter')
        console.error(err)
      })
  },
  [GET_COURSE_YEARS_STUDENTS] ({commit, dispatch, rootState}) {
    const actionData = { action: GET_COURSE_YEARS_STUDENTS, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/courseyear/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filterObject = {
          filterIdentifier: 'courseYears',
          filterName: 'student.filters.headers.year',
          filterAdditionalDescription: 'student.filters.headers.year_additional_description'
        }
        if (res.data.length > 6) {
          commit(SET_STUDENT_LIST_FILTER_TYPE, {filters: res.data, studentFilterObject: filterObject})
        } else {
          commit(SET_STUDENT_BUTTON_FILTER_TYPE, {filters: res.data, studentFilterObject: filterObject})
        }
        dispatch(GET_COURSE_LEVELS_STUDENTS)
      })
      .catch((err) => {
        console.log('Failed to get course years student filter')
        console.error(err)
      })
  },
  [GET_COURSE_LEVELS_STUDENTS] ({commit, dispatch, rootState}) {
    const actionData = { action: GET_COURSE_LEVELS_STUDENTS, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/course/courselevel/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filterObject = {
          filterIdentifier: 'courseLevels',
          filterName: 'student.filters.headers.level',
          filterAdditionalDescription: 'student.filters.headers.level_additional_description'
        }
        if (res.data.length > 6) {
          commit(SET_STUDENT_LIST_FILTER_TYPE, {filters: res.data, studentFilterObject: filterObject})
        } else {
          commit(SET_STUDENT_BUTTON_FILTER_TYPE, {filters: res.data, studentFilterObject: filterObject})
        }
        dispatch(GET_ENROLMENT_STATUS_STUDENTS)
      })
      .catch((err) => {
        console.log('Failed to get course levels student filter')
        console.error(err)
      })
  },
  [GET_ENROLMENT_STATUS_STUDENTS] ({commit, dispatch, rootState}) {
    const actionData = {action: GET_ENROLMENT_STATUS_STUDENTS, data: undefined}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/enrolmentstatus/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filterObject = {
          filterIdentifier: 'enrolmentStatus',
          filterName: 'student.filters.headers.enrolment_status',
          filterAdditionalDescription: 'student.filters.headers.enrolment_status_additional_description'
        }
        if (res.data.length > 6) {
          commit(SET_STUDENT_LIST_FILTER_TYPE, {filters: res.data, studentFilterObject: filterObject})
        } else {
          commit(SET_STUDENT_BUTTON_FILTER_TYPE, {filters: res.data, studentFilterObject: filterObject})
        }
        dispatch(GET_CUSTOM_FILTERS_FOR_STUDENTS)
      })
      .catch((err) => {
        console.log('Failed to get enrolment status student filter')
        console.error(err)
      })
  },
  [GET_CUSTOM_FILTERS_FOR_STUDENTS] ({commit, dispatch, rootState}) {
    const actionData = { action: GET_CUSTOM_FILTERS_FOR_STUDENTS, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/filter/student/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filters = res.data
        Object.keys(filters).forEach((filter) => {
          let filterIdentifier = filters[filter].filterIdentifier
          if (filters[filter].filterStyle === 'button') {
            commit(SET_STUDENT_CUSTOM_BUTTON_FILTER_TYPE, {filters, filter, filterIdentifier})
          } else {
            commit(SET_STUDENT_CUSTOM_LIST_FILTER_TYPE, {filters, filter, filterIdentifier})
          }
        })
        store.dispatch(GET_TUTOR_BOOLEAN)
        dispatch(GET_SAVED_FILTERS_FOR_STAFF, {filterName: [], filterType: ''})
      })
      .catch((err) => {
        console.log('Failed to get student filters')
        console.error(err)
      })
  },
  [GET_SAVED_FILTERS_FOR_STAFF] ({commit, dispatch, rootState, state}, filterObject) {
    if (state.holdDefaultSearch) {
      filterObject.hold = true
    }
    const actionData = { action: GET_SAVED_FILTERS_FOR_STAFF, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/search/staff/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        // set myFilters list values
        commit(SET_SAVED_FILTERS_FOR_STAFF, res.data)

        if (!filterObject.hold) {
          dispatch(ORGANISE_SAVED_FILTERS_FOR_STAFF, {data: res.data, filterObject: filterObject})
        }
      }).catch((err) => {
        console.error(err)
        console.log(`Failed to get saved filters for staff`)
      })
  },
  [CLEAR_SAVED_FILTERS_FOR_STAFF] ({commit, dispatch, rootState, state}) {
    // Clear all my student filters
    commit(CLEAR_STUDENTS_LIST_FILTERS)
    // Clear list types
    Object.keys(state.listSources).forEach((filterType) => {
      commit(SET_STUDENTS_LIST_FILTER_ARRAY, {filterName: [], filterType: filterType})
    })
  },
  [ORGANISE_SAVED_FILTERS_FOR_STAFF] ({commit, dispatch, rootState, state}, object) {
    dispatch(CLEAR_SAVED_FILTERS_FOR_STAFF)

    Object.keys(object.data).forEach(filter => {
      let myFilter = object.data[filter]
      // set default visibility
      myFilter.isHidden = false

      // check is default || is selected
      if (isDefault(object, myFilter) || isSelected(object, myFilter)) {
        if (!myFilter.isHidden) {
          // set myFilters button
          let ids = []
          ids.push(myFilter.id)
          commit(SET_STUDENTS_LIST_FILTER_ARRAY, {filterType: 'myFilterIds', filterName: ids})

          // include custom filter
          concatCustomFilters(myFilter)

          Object.keys(myFilter).forEach(key => {
            if (state.filterFields.hasOwnProperty(key)) {
              // set (myFilters) filters
              if (state.filterFields[key].isList) {
                commit(SET_STUDENTS_LIST_FILTER_ARRAY, {filterType: key, filterName: myFilter[key]})
              } else {
                commit(TOGGLE_STUDENTS_LIST_FILTER, {filterType: key, filterName: myFilter[key]})
              }
            }
          })
        }
      }
    })
    // Soft reset student list
    commit(SOFT_RESET_STUDENT_LIST)
    // call my students endpoint once all filters have been applied
    dispatch(GET_LIST_OF_STUDENTS)
  },
  [DELETE_SAVED_FILTER] ({rootState, state, commit, dispatch}, {id, toBeDeleted}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/search/delete/${id}/${toBeDeleted}`,
      method: 'delete',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: DELETE_SAVED_FILTER, data: {id, toBeDeleted}}
    }).then(() => {
      if (toBeDeleted) {
        commit(SAVE_DELETED_FILTER_ID, id)
        commit(SET_UNDO_TYPE, undoTypes.SAVE_FILTER_DELETION)
        dispatch(SET_UNDO_STATE_ASYNC, true)
        commit(HIDE_SAVED_FILTER_BY_ID, id)
        // if deleting selected
        let isSelected = state.filterFields.myFilterIds.values[id]
        if (isSelected) {
          dispatch(CLEAR_STUDENTS_LIST_FILTERS_ACTION)
        }
      } else {
        dispatch(SET_UNDO_STATE_ASYNC, false)
        commit(SHOW_SAVED_FILTER_BY_ID, id)
      }
      // reset dashboard
      commit(RESET_DASHBOARD_MODULE)
      // un cache charts so (dashboard) mounted actions can be recalled
      commit(DASHBOARD_CHARTS_NOT_CACHED)
    }).catch((err) => {
      console.error(err)
      if (toBeDeleted) {
        console.log(`Failed delete saved filter with id ${id}`)
        console.error(err)
      } else {
        console.log(`Failed to undo saved filter with id ${id}`)
        console.error(err)
      }
    })
  },
  [SAVE_UPDATE_MY_FILTER] ({commit, rootState, state, dispatch}, {description, defaultSearch, id, defaultAction}) {
    let filters = {}
    if (defaultAction) {
      setDefault(filters, state.filterFields.myFilterIds.myFilters, id, state.filterFields)
    } else {
      filters = getAppliedFilters(state.filterFields)
      solveCustomFilters(filters, state.customFilterNames)
    }
    filters.description = description
    filters.defaultSearch = defaultSearch
    filters.id = id
    return axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/search/update/`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: filters,
      actionData: { action: SAVE_UPDATE_MY_FILTER, data: filters }
    }).then(res => {
      let ids = []
      ids.push(res.data.id)
      dispatch(GET_SAVED_FILTERS_FOR_STAFF, {filterName: ids, filterType: 'myFilterIds'})
      // reset dashboard
      commit(RESET_DASHBOARD_MODULE)
      // un cache charts so (dashboard) mounted actions can be recalled
      commit(DASHBOARD_CHARTS_NOT_CACHED)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.SAVE_FILTER_CREATED)
    }).catch(err => {
      console.error(err)
    })
  },
  [GET_COURSES_FOR_STUDENTS] ({commit, dispatch, rootState}) {
    const actionData = { action: GET_COURSES_FOR_STUDENTS, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/course/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        commit(SET_COURSES_FOR_STUDENTS, res.data)
      })
  },
  [DOWNLOAD_STUDENT_REPORT] ({commit, rootState, state}) {
    if (!state.report_downloading) {
      commit(STUDENT_REPORT_LOADING)
      commit(STUDENT_REPORT_LOADING_LABEL)
      const actionData = { action: DOWNLOAD_STUDENT_REPORT, data: undefined }
      let filters = {}
      filters = getAppliedFilters(state.filterFields)
      solveCustomFilters(filters, state.customFilterNames)
      axios({
        url: `${rootState.config.baseUrl}:${rootState.config.port}/core/report/myStudents/`,
        method: 'post',
        headers: {
          'Authorization': rootState.profile.loginToken
        },
        data: {
          pageNumber: 0,
          pageSize: 80000,
          ascDesc: state.sortBy.split(':::')[1],
          sortBy: state.sortBy.split(':::')[0],
          searchString: state.searchString,
          ...filters
        },
        actionData,
        responseType: 'blob'
      }).then(res => {
        const name = `MyStudents report.csv`
        FileSaver.saveAs(res.data, name)
        commit(STUDENT_REPORT_FINISHED_LOADING)
        commit(STUDENT_REPORT_FINISHED_LABEL)
      }).catch(err => {
        console.error(err)
        console.log(`Failed to download the student report`)
        commit(STUDENT_REPORT_FINISHED_LOADING)
        commit(STUDENT_REPORT_FINISHED_LABEL)
      })
    }
  },
  [LOGOUT] (context) {
    context.commit(RESET_STUDENTS_MODULE)
  },
  [GET_MY_STUDENT_COLUMNS] ({commit, dispatch, rootState, state}) {
    const actionData = { action: GET_MY_STUDENT_COLUMNS, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core//student/mystudent/columns`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        commit(SET_MY_STUDENT_COLUMNS, res.data)
        res.data.forEach(el => {
          commit(BUILD_MY_STUDENT_ELEMENTS, el.columnName)
        })
      })
  }
}

const mutations = {
  [SET_STUDENT_BUTTON_FILTER_TYPE] (state, {filters, studentFilterObject}) {
    let filterObject = {}
    filterObject.filterName = studentFilterObject.filterIdentifier
    filterObject.header = studentFilterObject.filterAdditionalDescription
    filterObject.values = {}
    Object.keys(filters).forEach((filter) => {
      filterObject.values[filters[filter].code] = {}
      filterObject.values[filters[filter].code].value = false
      filterObject.values[filters[filter].code].text = filters[filter].description
    })
    // add to state.filterFields object
    Vue.set(state.filterFields, filterObject.filterName, filterObject)
  },
  [SET_STUDENT_LIST_FILTER_TYPE] (state, {filters, studentFilterObject}) {
    let filterObject = {}
    let filterIdentifier = studentFilterObject.filterIdentifier

    filterObject.filterName = studentFilterObject.filterIdentifier
    filterObject[filterIdentifier] = {}
    filterObject[filterIdentifier].header = studentFilterObject.filterAdditionalDescription
    filterObject[filterIdentifier].isList = true
    filterObject[filterIdentifier].listName = studentFilterObject.filterIdentifier
    filterObject[filterIdentifier].values = {}

    filterObject[filterIdentifier][filterIdentifier] = []
    let filterListArray = filterObject[filterIdentifier][filterIdentifier]

    let iterator = filters.keys()
    for (let key of iterator) {
      filterObject[filterIdentifier].values[filters[key].code] = {}
      filterObject[filterIdentifier].values[filters[key].code].value = false
      filterObject[filterIdentifier].values[filters[key].code].text = filters[key].description

      let filterListObject = {}
      filterListObject.id = key
      filterListObject.description = filters[key].description
      filterListObject.identifier = filters[key].code
      filterListArray.push(filterListObject)
    }
    // add to state.filterFields object
    Vue.set(state.filterFields, filterObject.filterName, filterObject[filterObject.filterName])

    let source = {}
    source[filterIdentifier] = {}
    source[filterIdentifier].identifier = filterIdentifier
    source[filterIdentifier].title_i18n = studentFilterObject.filterName
    source[filterIdentifier].items = filterListArray
    source[filterIdentifier].idValues = {}
    source[filterIdentifier].button_i18n = '{count} ' + studentFilterObject.filterName + ' ::: {count} ' + studentFilterObject.filterAdditionalDescription
    source[filterIdentifier].button_unselected_i18n = studentFilterObject.filterAdditionalDescription
    source[filterIdentifier].containsText = function containsText (item, text) {
      return (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
        (item.identifier.toUpperCase().indexOf(text.toUpperCase()) >= 0)
    }
    source[filterIdentifier].key = function key (item) {
      return item.identifier
    }
    source[filterIdentifier].mapRow = function mapRow (item) {
      return {
        rows: [item.description, item.identifier],
        id: item.identifier
      }
    }
    // add to state.listSources object
    Vue.set(state.listSources, filterIdentifier, source[filterIdentifier])
  },
  [SET_STUDENT_CUSTOM_BUTTON_FILTER_TYPE] (state, {filters, filter, filterIdentifier}) {
    if (!state.customFilterNames[filterIdentifier]) {
      state.customFilterNames.push(filterIdentifier)
      let filterObject = {}
      filterObject.filterName = filterIdentifier
      filterObject[filterIdentifier] = {}
      filterObject[filterIdentifier].header = filters[filter].description
      filterObject[filterIdentifier].values = {}

      Object.keys(filters[filter]['filterTypeCodes']).forEach((filterValue) => {
        let filterTypeCodes = filters[filter]['filterTypeCodes'][filterValue]
        filterObject[filterIdentifier].values[filterTypeCodes.code] = {}
        filterObject[filterIdentifier].values[filterTypeCodes.code].value = false
        filterObject[filterIdentifier].values[filterTypeCodes.code].text = filterTypeCodes.description
      })
      // add to state.filterFields object
      Vue.set(state.filterFields, filterObject.filterName, filterObject[filterObject.filterName])
    }
  },
  [SET_STUDENT_CUSTOM_LIST_FILTER_TYPE] (state, {filters, filter, filterIdentifier}) {
    if (!state.customFilterNames.includes(filterIdentifier)) {
      state.customFilterNames.push(filterIdentifier)
      let filterObject = {}
      filterObject.filterName = filterIdentifier
      filterObject[filterIdentifier] = {}
      filterObject[filterIdentifier].header = filters[filter].description
      filterObject[filterIdentifier].isList = true
      filterObject[filterIdentifier].listName = filterIdentifier
      filterObject[filterIdentifier].values = {}

      filterObject[filterIdentifier][filterIdentifier] = []
      let filterListArray = filterObject[filterIdentifier][filterIdentifier]
      Object.keys(filters[filter]['filterTypeCodes']).forEach((filterValue) => {
        let filterTypeCodes = filters[filter]['filterTypeCodes'][filterValue]
        filterObject[filterIdentifier].values[filterTypeCodes.code] = {}
        filterObject[filterIdentifier].values[filterTypeCodes.code].value = false
        filterObject[filterIdentifier].values[filterTypeCodes.code].text = filterTypeCodes.description

        let filterListObject = {}
        filterListObject.id = filterTypeCodes.id
        filterListObject.description = filterTypeCodes.description
        filterListObject.identifier = filterTypeCodes.code
        filterListArray.push(filterListObject)
      })
      // add to state.filterFields object
      Vue.set(state.filterFields, filterObject.filterName, filterObject[filterObject.filterName])

      let source = {}
      source[filterIdentifier] = {}
      source[filterIdentifier].identifier = filterIdentifier
      source[filterIdentifier].title_i18n = filters[filter].description
      source[filterIdentifier].items = filterListArray
      source[filterIdentifier].idValues = {}
      source[filterIdentifier].button_i18n = '{count} ' + filters[filter]['description'] + ' ::: {count} ' + filters[filter]['additionalDescription']
      source[filterIdentifier].button_unselected_i18n = filters[filter]['additionalDescription']
      source[filterIdentifier].containsText = function containsText (item, text) {
        return (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
               (item.identifier.toUpperCase().indexOf(text.toUpperCase()) >= 0)
      }
      source[filterIdentifier].key = function key (item) {
        return item.identifier
      }
      source[filterIdentifier].mapRow = function mapRow (item) {
        return {
          rows: [item.description, item.identifier],
          id: item.identifier
        }
      }
      // add to state.listSources object
      Vue.set(state.listSources, filterIdentifier, source[filterIdentifier])
    }
  },
  [ADD_STUDENTS_TO_LIST] (state, students) {
    students.map(student => Object.freeze(student))
    state.students = state.students.concat(students)
  },
  [STUDENTS_LIST_LOADING] (state) {
    state.loading = true
  },
  [STUDENTS_LIST_NOT_LOADING] (state) {
    state.loading = false
  },
  [SET_IS_TUTOR] (state, isNotTutor) {
    state.filterFields.myTutees.isNotTutor = !isNotTutor
  },
  [SET_SORTING] (state, sortField) {
    state.sortBy = sortField
  },
  [UPDATE_PAGE] (state) {
    state.currentPage++
  },
  [SET_LAST_PAGE] (state, last) {
    state.lastPage = last
  },
  [SOFT_RESET_STUDENT_LIST] (state) {
    state.students = []
    state.lastPage = false
    state.currentPage = -1
    state.scrollTop = 0
  },
  [SET_TOTAL_ELEMENTS] (state, totalElements) {
    state.totalElements = totalElements
  },
  [SET_STUDENT_LIST_SCROLL_TOP] (state, scrollTop) {
    state.scrollTop = scrollTop
  },
  [SET_STUDENT_LIST_SEARCH_FIELD] (state, searchString) {
    state.searchString = searchString
  },
  [SET_STUDENT_LIST_SEARCH_FIELD_DISPLAY] (state, searchString) {
    state.searchStringDisplay = searchString
  },
  [TOGGLE_STUDENTS_LIST_FILTER] (state, {filterType, filterName}) {
    // if array has multiple elements
    if (Array.isArray(filterName)) {
      filterName.forEach(item => {
        state.filterFields[filterType].values[item].value = !state.filterFields[filterType].values[item].value
      })
    } else {
      state.filterFields[filterType].values[filterName].value = !state.filterFields[filterType].values[filterName].value
    }
  },
  [SET_STUDENTS_LIST_FILTER_ARRAY] (state, {filterType, filterName}) {
    let items = {}
    filterName.forEach(item => {
      items[item] = {value: true}
    })
    state.filterFields[filterType].values = items
    state.listSources[filterType].idValues = items
  },
  [CLEAR_STUDENTS_LIST_FILTERS] (state) {
    state.filterFields = clearFilters(state.filterFields)
  },
  [SET_COURSES_FOR_STUDENTS] (state, courses) {
    state.filterFields.courseIds.courses = courses
    state.listSources.courseIds.items = courses
  },
  [SET_SAVED_FILTERS_FOR_STAFF] (state, filters) {
    state.filterFields.myFilterIds.myFilters = filters
    state.listSources.myFilterIds.items = filters
    // set default button description
    Object.keys(filters).forEach(filter => {
      if (filters[filter].defaultSearch) {
        state.listSources.myFilterIds.button_i18n = filters[filter].description
      }
    })
  },
  [SET_STUDENTS_LIST_IS_FILTERING] (state, isFiltering) {
    state.filtersApplied = isFiltering
  },
  [RESET_STUDENTS_MODULE] (s) {
    const initial = state()
    Object.keys(initial).forEach(key => { s[key] = initial[key] })
  },
  [HIDE_SAVED_FILTER_BY_ID] (state, id) {
    changeSavedFilterVisibility(state.filterFields.myFilterIds.myFilters, id, true)
  },
  [SHOW_SAVED_FILTER_BY_ID] (state, id) {
    changeSavedFilterVisibility(state.filterFields.myFilterIds.myFilters, id, false)
  },
  [SAVE_DELETED_FILTER_ID] (state, id) {
    state.lastDeletedFilterId = id
    console.log('Last deleted Filter Id' + state.lastDeletedFilterId)
  },
  [STUDENT_REPORT_LOADING] (state) {
    state.report_downloading = true
  },
  [STUDENT_REPORT_FINISHED_LOADING] (state) {
    state.report_downloading = false
  },
  [STUDENT_REPORT_LOADING_LABEL] (state) {
    state.report_download_button_label = 'student.report_download_in_progress'
  },
  [STUDENT_REPORT_FINISHED_LABEL] (state) {
    state.report_download_button_label = 'student.report_download'
  },
  [HOLD_DEFAULT_SEARCH] (state, hold) {
    state.holdDefaultSearch = hold
  },
  [BUILD_MY_STUDENT_ELEMENTS] (state, header) {
    state.headers[header].html = buildHeaderClass(state.headers[header])
  },
  [SET_MY_STUDENT_COLUMNS] (state, columns) {
    let obj = {}
    columns.forEach(el => {
      obj[el.columnName] = {}
      obj[el.columnName].xs = el.xs
      obj[el.columnName].sm = el.sm
    })
    state.headers = obj
  }
}

export default {
  state: state(),
  actions,
  mutations
}

export const changeSavedFilterVisibility = (obj, id, hidden) => {
  Object.keys(obj).forEach(myFilter => {
    if (obj[myFilter].id === id) {
      obj[myFilter].isHidden = hidden
    }
  })
}

export const setDefault = (obj, myFilters, id, filterFields) => {
  Object.keys(myFilters).forEach(filter => {
    // update selected only
    if (myFilters[filter].id === id) {
      Object.keys(myFilters[filter]).forEach(prop => {
        // check if property is filterField
        if (filterFields.hasOwnProperty(prop) || prop === 'filters') {
          Vue.set(obj, prop, myFilters[filter][prop])
        }
      })
    }
  })
}

export const solveCustomFilters = (obj, names) => {
  //  implement custom filters object
  obj.filters = null
  if (names.length !== 0) {
    obj.filters = []
    for (const el of names.values()) {
      if (obj[el] !== null) {
        let element = {}
        element['filterCodes'] = []
        element['filterCodes'] = obj[el]
        element['filterIdentifier'] = el

        obj.filters.push(element)
      }
    }
  }
}

export const concatCustomFilters = (myFilter) => {
  Object.keys(myFilter).forEach(key => {
    if (key === 'filters') {
      myFilter[key].forEach(el => {
        myFilter[el.filterIdentifier] = el.filterCodes
      })
    }
  })
}

export const isDefault = (object, myFilter) => {
  return object.filterObject.filterName.length === 0 && myFilter.defaultSearch
}

export const isSelected = (object, myFilter) => {
  return myFilter.id === Object.values(object.filterObject.filterName)[0]
}

export const buildHeaderClass = (object) => {
  const ob = []
  Object.entries(object).forEach(el => {
    if (!el.includes('html')) {
      ob.push(el.join(''))
    }
  })
  return ob.join(' ')
}



// WEBPACK FOOTER //
// ./src/store/modules/students.js